import { IMembershipPrice, IPrice } from '@/shared';
import { hrApiClient } from '../clients';

export async function getPriceList(groupId: number) {
  const response = await hrApiClient.get<IPrice[]>(
    `/price/prices?groupId=${groupId}`
  );
  return response.data;
}
export async function getMembershipPrices() {
  const response = await hrApiClient.get<IMembershipPrice[]>(
    '/price/membership-prices/public'
  );
  return response.data;
}
